/*
Description: This is the file that will handle interacting with the JaneApp EMR
Date: 11/29/2023
Author: Jacob Michalski


TODO: 
    Make the template start with a SOAP note and fill it in with your template...


Notes:
    All Injectors need the following functions:
        getQuestions
        answerQuestions (Consider combining these and making the single a private function)
        answerQuestion



JaneApp Specific Notes:
    Each Visit get's a Chart Entry

        class: chart-entry (We want the newest, first instance)
            var chart = document.querySelector(".chart-entry")
            data-test-id="chart_entry_header_date" (The date of the visit)
                let date = chart.querySelector('[data-test-id="chart_entry_header_date"]').textContent.trim();
            data-test-id="chart_entry_header_title" (The title of visit - This must include Comprehend or something...)
                let title = chart.querySelector('[data-test-id="chart_entry_header_date"]').textContent.trim();
            
            class: chart-entry-body (The List of questions in the chart entry)
                let body = chart.querySelector(".chart-entry-body")
                    let questions = body.querySelectorAll(".chart-part-row")
                        # Long Answer (Prompt is in the label)
                            menu-toggle-container (Label)
                                q.querySelector(".menu-toggle-container").textContent.trim()
                            ql-editor (The input box (Has the prompt if any))
                                q.querySelector(".ql-editor").textContent = xxx

                        
                        # Header
                            menu-toggle-container (Label)
                                q.querySelector(".menu-toggle-container").textContent.trim()
                            ql-editor == None
                            
                        # Slider
                            menu-toggle-container (Label)
                                q.querySelector(".menu-toggle-container").textContent.trim()
                            range-padding
                                q.querySelector(".range-padding").firstChild.min
                                q.querySelector(".range-padding").firstChild.max
                                q.querySelector(".range-padding").firstChild.value = xxx

                        # Checkbox
                            menu-toggle-container (Label)
                                q.querySelector(".menu-toggle-container").textContent.trim()
                            input type="checkbox"
                                q.querySelector("input").checked = true
                                & q.querySelector(".styled-checkbox").classList.add("checked")

                        # Dropdown (Multiple Choice)
                            menu-toggle-container (Label)
                                q.querySelector(".menu-toggle-container").textContent.trim()
                            form-control (Dropdown)
                                var options = q.querySelector(".form-control")
                                    option
                                    q.querySelectorAll("option")

                            





*/

const DEFAULT_DOB = '05/29/2023';

/** Main Functions */
export function getPageInfo() {
  /*
    Description: This function will get the page info from the note
    Return: A dictionary with the page info
        {
            "URL": Base URL for the page,
            "Note Type": "PT Daily/SOAP Note",...
        }
    */
  const baseURL = window.location.origin;

  // Check if the element exists and get its text content
  let openChart = getOpenChartEntry();
  let noteTypeElement = openChart.querySelector(
    'span[data-test-id="chart_entry_header_title"]'
  );
  let noteType = noteTypeElement ? noteTypeElement.textContent.trim() : null;
  noteType = noteType?.replace('– ', '').trim(); // Replace a leading – if it exists

  return {
    URL: baseURL,
    'Note Type': noteType || 'Default Note'
  };
}

export function getPatientInfo() {
  /*
    Description: This function will get the patient info from the note
    Return: A dictionary with the patient info
    {
        "EMR ID": 0x1234 or "michalskij"
        "First Name":firstName,
        "Last Name": lastName,
        "DOB": dob,
    }
    */
  // name=ctl00_cp1_patientFirst
  // use the query selector to get the patient info
  const nameElement = document.querySelector(
    '#user_profile_header .page-header h1 span'
  );
  if (!nameElement) {
    return null;
  }
  const fullName = nameElement.textContent.trim();
  const [firstName, lastName] = fullName.split(' ', 2);

  const emrID = window.location.href.match(/patients\/(\d+)/)[1];
  const dob = getDOB();

  return {
    'EMR ID': emrID,
    'First Name': firstName,
    'Last Name': lastName,
    DOB: dob
  };
}
function getDOB() {
  // Step 1: Select the element containing the date
  // Assuming the structure of the HTML remains consistent
  let birthDateElement = document.querySelector(
    '.section.text-selectable.sensitive span.text-muted'
  );

  if (!birthDateElement) {
    console.error('Birth date element not found');
    return DEFAULT_DOB;
  }
  birthDateElement = birthDateElement.nextSibling;

  // Step 2: Extract the text content
  let birthDate = birthDateElement.textContent.trim();
  return birthDate;
}

// Create a new value setter event
function setReactInputComponent(input, value) {
  // Safely get the property descriptor for 'value'
  const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value'
  ).set;

  // Set the value using the native value setter
  nativeInputValueSetter.call(input, value);

  // Dispatch the event using React's event system
  const event = new Event('input', { bubbles: true });
  input.dispatchEvent(event);
}

// Function to change the value
function setReactSelectComponent(select, value) {
  // Create a new value setter event
  const nativeSelectValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLSelectElement.prototype,
    'value'
  ).set;

  // Set the value using the native value setter
  nativeSelectValueSetter.call(select, value);

  // Dispatch the 'change' event
  const event = new Event('change', { bubbles: true });
  select.dispatchEvent(event);
}

/* 
questions - This is where we will store the questions
          - a list of dictionaries
     [{
        "Question": "Where was the injury?", 
        "Type": "Multiple Choice", 
        "Choices": ["Back", "Neck", "Shoulder"]
     },
        ...
        ]

*/
var questions = [];

/*
question Interactions - This is where we will store the interactions for each question
                        - a dictionary of dictionaries
         {
            "Where was the injury?": {
                "Type": "Multiple Choice",
                "Choices"{
                    "Back": () => {click the back button},
                    "Neck": () => {click the neck button},
                    "Shoulder": () => {click the shoulder button}
                }
            },
        },
        {
            "What is the injury?": {
                "Type": "Long Answer",
                "Input": (val) => {input the value into the input box}
        }
            ...
         }
*/
var questionInteractions = {};

var header = '';

function getOpenChartEntry() {
  // Get the most recent Chart Entry that's actually open
  let c = document.querySelectorAll('.chart-entry');
  for (var i = 0; i < c.length; i++) {
    let qs = c[i].querySelectorAll('.chart-part-row');
    if (qs.length > 0) {
      return c[i];
    }
  }
}

export function getQuestions() {
  // Nuke any left over's from last time
  questions = [];

  // Get the most recent Chart Entry
  var chart = getOpenChartEntry();

  // Get the date and title for the chart entry
  let date = chart
    .querySelector('[data-test-id="chart_entry_header_date"]')
    .textContent.trim();
  let title = chart
    .querySelector('[data-test-id="chart_entry_header_date"]')
    .textContent.trim();

  // Get the body of the chart entry and iterate through the questions
  let body = chart.querySelector('.chart-entry-body');
  let qs = body.querySelectorAll('.chart-part-row');
  for (var i = 0; i < qs.length; i++) {
    try {
      // console.log("\n")
      // console.log("Question " + i)
      // console.log("Question Length = ", questions.length)

      // Check for the top level questions
      if (qs[i].querySelector('.ql-editor')) {
        shortAnswer(qs[i]);
      } else if (qs[i].querySelector('.range-padding')) {
        // Slider
        slider(qs[i]);
      } else if (qs[i].querySelector('[type="checkbox"]')) {
        // Choose all - Toggle Box
        checkbox(qs[i]);
      } else if (qs[i].querySelector('.form-control')) {
        // Multiple Choice
        multipleChoice(qs[i]);
      } else if (qs[i].querySelector('.menu-toggle-container')) {
        // Header
        // All of them will have this so it has to go last
        console.log('Header');
        header = qs[i]
          .querySelector('.menu-toggle-container')
          .textContent.trim();
      } else {
        console.error('Unknown Question Type');
        console.log(qs[i]);
      }
    } catch (e) {
      console.error('Error');
      console.error(e);
    }
  }

  console.log('Questions');
  console.log(questions);
  return questions;
}

function getQuestionName(q) {
  let qLocal = q.querySelector('.menu-toggle-container');
  let qLocalTight = qLocal.querySelector('h1, h2, h3, h4, h5, h6');
  if (qLocalTight && qLocalTight.textContent) {
    return qLocalTight.textContent.trim();
  } else {
    return qLocal.textContent.trim();
  }
}

function shortAnswer(q) {
  console.log('Long Answer');
  // Long Answer

  var question = header + '\n' + getQuestionName(q);
  var qKey = getQuestionName(q);
  if (qKey == '') {
    qKey = question;
  }
  if (q.querySelector('.ql-editor').textContent.trim() != '') {
    question +=
      '\n\nTemplate: ' + q.querySelector('.ql-editor').textContent.trim();
  }
  question = question.trim();
  var type = 'Long Answer';

  let existingNote = getExistingNote(q.querySelector('.ql-editor').textContent);

  questions.push({
    Key: qKey,
    Question: question.trim(),
    Type: type,
    ExistingNote: existingNote
  });
  questionInteractions[question] = {
    Type: type,
    ExistingNote: existingNote,
    Input: (val, replyType) => {
      if (isEmptyOrNull(val)) {
        return;
      }
      if (replyType == 'append') {
        q.querySelector('.ql-editor').textContent = (
          q.querySelector('.ql-editor').textContent +
          '\n' +
          val
        ).trim();
      } else {
        q.querySelector('.ql-editor').textContent = val;
      }
    }
  };
}

function isEmptyOrNull(value) {
  return (
    value === null || value === undefined || value === '' || value === 'None'
  );
}

function genList(min, max) {
  var list = [];
  for (var i = min; i <= max; i++) {
    list.push(i.toString());
  }
  return list;
}

function slider(q) {
  console.log('Slider');
  // Slider
  var question = header + '\n' + getQuestionName(q);
  var qKey = getQuestionName(q);
  if (qKey == '') {
    qKey = question;
  }

  var min = q.querySelector('.range-padding').firstChild.min;
  var max = q.querySelector('.range-padding').firstChild.max;
  var type = 'Multiple Choice';

  questions.push({
    Key: qKey,
    Question: question,
    Type: type,
    Choices: genList(min, max)
  });
  var choices = {};
  function setSliderValue(i) {
    setReactInputComponent(
      q.querySelector('.range-padding').firstChild,
      i.toString()
    );
    // q.querySelector(".range-padding").firstChild.value = i.toString()
  }
  for (var i = min; i <= max; i++) {
    // This is necessary to make sure we are allocating a new memory location for each function...
    (function (i) {
      choices[i.toString()] = function () {
        setSliderValue(i);
      };
    })(i);
  }

  questionInteractions[question] = {
    Type: type,
    Choices: choices
  };
}

function checkbox(q) {
  // TODO!! There are potentially multiple checkboxes here...
  console.log('Checkbox');
  // Checkbox
  var question = header + '\n' + getQuestionName(q);
  var qKey = getQuestionName(q);
  if (qKey == '') {
    qKey = question;
  }
  var type = 'Multiple Choice';

  questions.push({
    Key: qKey,
    Question: question,
    Type: type,
    Choices: ['Yes', 'No']
  });
  questionInteractions[question] = {
    Type: type,
    Choices: {
      Yes: () => {
        q.querySelector('input').checked = true;
        q.querySelector('.styled-checkbox').classList.add('checked');
      },
      No: () => {
        q.querySelector('input').checked = false;
        q.querySelector('.styled-checkbox').classList.remove('checked');
      }
    }
  };
}

function multipleChoice(q) {
  console.log('Multiple Choice');
  // Multiple Choice
  var question = header + '\n' + getQuestionName(q);
  var qKey = getQuestionName(q);
  if (qKey == '') {
    qKey = question;
  }
  var choices = [];
  var type = 'Multiple Choice';
  var options = q.querySelector('.form-control');
  var optionsList = options.querySelectorAll('option');
  var optionsClickable = {};
  optionsList.forEach((option) => {
    if (option.textContent.trim() != 'Select an option...') {
      choices.push(option.textContent.trim());
      optionsClickable[option.textContent.trim()] = () => {
        setReactSelectComponent(options, option.textContent.trim());
        // options.value = option.textContent
      };
    }
  });

  questions.push({
    Key: qKey,
    Question: question,
    Type: type,
    Choices: choices
  });
  questionInteractions[question] = {
    Type: type,
    Choices: optionsClickable
  };
}

export function answerQuestions(answers) {
  /*
    Description: This function will take the answers and populate the questions
    
    Args: 
        answers: A dictionary of answers
            "Question": "The question in question"
            "Answer": "The answer to the question"
   
    Return: A list of any questions that were not answered, perhaps the answer didn't match the questions expected or whatnot...
        [
            {
                Question: "Where was the injury?", 
                Answer: "Back" 
                Error: "The error message" (Choice not found, etc)
            },
            ...
        }

    */
  var errors = [];
  answers.forEach((answer) => {
    var error = answerQuestion(
      answer['Question'],
      answer['Answer'],
      answer['Reply Type']
    );
    if (error) {
      errors.push({
        Question: answer['Question'],
        Answer: answer['Answer'],
        Error: error
      });
    }
  });
  console.error('Errors:');
  console.error(errors);
  return errors;
}

export function answerQuestion(question, answer, replyType) {
  /*
    Description: This function will take the answer and populate the question
    
    Args: 
        question: The question in question
        answer: The answer to the question
   
    Return: null if success otherwise a string with the error message
    */

  // console.log("Answering Question: '" + question + "' with '" + answer+"'")

  // Make sure the question exists
  if (questionInteractions[question] == null) {
    console.error('Question not found');
    console.error(question);
    // console.log(questionInteractions)
    // console.log(Object.keys(questionInteractions))

    return 'Question not found';
  }

  // If it is a Long Answer or long answer, just populate the input
  if (questionInteractions[question]['Input']) {
    questionInteractions[question]['Input'](answer, replyType);
    return true;
  }

  // Check if the answer is a list of answers or just a single answer
  if (Array.isArray(answer)) {
    // Choose All
    var notFoundAnswers = [];
    for (var i = 0; i < answer.length; i++) {
      if (answer[i] in questionInteractions[question]['Choices']) {
        console.log('Answer found ' + answer[i]);
        questionInteractions[question]['Choices'][answer[i]](true);
        // sleep(1000).then(() => {
        //     questionInteractions[question][answer[i]]()
        // });
      } else {
        notFoundAnswers.push(answer[i]);
      }
    }
    if (notFoundAnswers.length > 0) {
      console.error('The following answers were not found: ' + notFoundAnswers);
      return 'The following answers were not found: ' + notFoundAnswers;
    } else {
      return true;
    }
  } else {
    // Multiple Choice
    if (answer in questionInteractions[question]['Choices']) {
      questionInteractions[question]['Choices'][answer]();
      return true;
    } else {
      console.error('Answer not found');
      console.log('Question: ' + question);
      console.log('Answer:' + answer);
      console.log(questionInteractions[question]['Choices']);
      return 'Answer not found';
    }
  }
}

function getExistingNote(value) {
  if (typeof value !== 'string') {
    return null;
  }

  let val = value?.trim();
  return val === '' ? null : val;
}

export async function getLogFromInjector() {
  try {
    const htmlContent = document.documentElement.outerHTML;
    chrome.runtime.sendMessage({
      type: 'INJECTOR_ERROR',
      error: { htmlContent: htmlContent }
    });
    return { htmlContent: htmlContent };
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    getLogFromInjector();
  }
}
